// Component
const AuthSetPass = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-set-password" */ '@/app/views/auth-view/components/auth-set-password/auth-set-password.vue');

export default {
	name: 'ChangePasswordContainer',
	components: {
		AuthSetPass
	},
	data() {
		return {
			credentials: {
				currentPass: null,
				password: null,
				confirmPass: null
			},
			dontShowModal: false
		}
	},
	methods: {
		changePass(details) {
			this.credentials = {...details};
		},
		doNotShowModalAlert(){
			this.dontShowModal = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		const {currentPass, password, confirmPass} = this.credentials;

		if ((currentPass || password || confirmPass) && !this.dontShowModal && to.path !== '/login') {
			this.$swal({
				imageHeight: '30px',
				title: 'You have unsaved changes!',
				text: 'Are you sure you want to leave this page?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				confirmButtonColor: '#4B8BFF',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true
			})
				.then(result => {
					if (result.value) {
						next(true);
					} else {
						next(false);
					}
				});
		} else {
			next(true);
		}
	}
}